import { render, staticRenderFns } from "./editMallMenu.vue?vue&type=template&id=58cbc348"
import script from "./editMallMenu.vue?vue&type=script&lang=js"
export * from "./editMallMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports